if (!customElements.get("product-multicolumn")) {
  // 注册自定义元素
  customElements.define(
    "product-multicolumn",
    class ProductMulticolumn extends HTMLElement {
      constructor() {
        super();
        // 初始化元素的状态或属性
        this.data = {
          pcCount: parseInt(
            this.querySelector(".custom-multicolumn-wrapper").getAttribute(
              "data-pccolumns"
            )
          ),
          padCount: parseInt(
            this.querySelector(".custom-multicolumn-wrapper").getAttribute(
              "data-padcolumns"
            )
          ),
          mbCount: parseInt(
            this.querySelector(".custom-multicolumn-wrapper").getAttribute(
              "data-mbcolumns"
            )
          ),
        };
      }
      connectedCallback() {
        // 元素被添加到DOM时调用
        // 初始化元素
        this.initSwiper(this.querySelector(".custom-multicolumn-wrapper"));
      }
      initSwiper(multicolumnList) {
        // 如果已经初始化了 swiper，先销毁它
        if (this.swiper) {
          this.swiper.destroy();
        }

        // 初始化 swiper
        this.swiper = new Swiper(multicolumnList, {
          spaceBetween: 50, // 列之间的间距
          slidesPerGroup: 1,
          loop: true,
          autoplay: true,
          centeredSlidesBounds: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".custom-multicolumn-wrapper .swiper-pagination",
          },
          breakpoints: {
            1000: {
              slidesPerView: this.data.pcCount || 3,
            },
            590: {
              slidesPerView: this.data.padCount || 2, // 平板时显示2列
              spaceBetween: 20,
            },
            320: {
              slidesPerView: this.data.mbCount || 1, // 手机时显示1列
            },
          },
        });
      }
    }
  );
}
